import { cache } from '@/util'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { mapGetters, mapMutations } from 'vuex'
import * as types from '@contact/store/types'

@Component({
    computed: {
        ...mapGetters({
            selectionList: types.CONTACT_SELECTION
        })
    },
    methods: {
        ...mapMutations({
            setCurreuntItem: types.CURRENT_CONTACT_ITEM,
            selectContact: types.CONTACT_SELECTION
        })
    }
})
export default class ContactListItem extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: P R O P : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    @Prop({ type: Object }) item!: contacts.ContactItem
    @Prop({ type: Boolean, default: false }) toggle!: boolean
    @Prop({ type: Boolean, default: false }) isChecked!: boolean

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    selectionList!: string[]

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //
    
    setCurreuntItem!: (item: contacts.ContactItem) => void
    selectContact!: (item: contacts.ContactItem) => void

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    avatar = {
        url: '',
        loading: false,
    };
    check: boolean = false

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get isSelected() {
        return this.selectionList.includes(this.item.id) ? true : false
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E H T O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    //연락처 상세정보 뷰
    loadContact() {
        let item = this.item;
        this.setCurreuntItem(item)
        this.$router.push({ name: 'contact-view' })
    }

    error(e: Event) {
        var elem = e.srcElement as HTMLImageElement
        elem.src = '/cm/gres/v1/img/ghost_loading.png'
    }

    errorGhost(e: Event) {
        var elem = e.srcElement as HTMLImageElement;
        elem.src = '/cm/gres/faux/images/ghost.png'
    }

    getImage(senderMail?: string) {
        if (senderMail && senderMail.indexOf('/') == -1) {
            this.avatar.loading = true;
            cache.avatar.get(senderMail).then((url: string) => {
                this.avatar.url = url;
                this.avatar.loading = false;
            });
        }
    }

    checked() {
        this.selectContact(this.item)
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    created() {
        if (this.item.email) {
            this.getImage(this.item.email);
        }
    }
}
